import React from 'react';
import classnames from 'classnames';
import * as styles from '../base.scss';
import { translate } from 'Shared/translate';
import Info from 'Shared/Info';
const InfoBlock = (props) => {
    return (props.info &&
        React.createElement("div", { className: classnames(styles.infoRow, { [styles.infoRowCheckout]: props.isCheckout }) },
            React.createElement("div", null,
                props.isDesktop && React.createElement("div", { className: styles.h2 }, translate(props.headerText)),
                React.createElement(Info, { text: props.info }))));
};
export default InfoBlock;
